import { onBeforeUnmount, onMounted, shallowRef } from 'vue'

export function useOverlayViewport() {
  const style = shallowRef<Record<string, string>>({})
  let viewport: VisualViewport | null = null

  function update() {
    style.value = {
      '--overlay-viewport-height': `${viewport?.height ?? window.innerHeight}px`,
      '--overlay-viewport-top': `${viewport?.offsetTop ?? 0}px`,
    }
  }

  onMounted(() => {
    viewport = window.visualViewport
    update()
    window.addEventListener('resize', update)
    viewport?.addEventListener('resize', update)
    viewport?.addEventListener('scroll', update)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', update)
    viewport?.removeEventListener('resize', update)
    viewport?.removeEventListener('scroll', update)
  })

  return style
}
